import {partySize} from 'root-config/constants.js'
import PartyPicker from '../../../defaultFlow/tabs/tour-overview/partyPicker.jsx'

export default class PartyPickerDayTour extends PartyPicker {
  constructor (options) {
    super(options)
  }

  getMaximumChildrenNumber (adults) {
    if (!adults || adults < partySize.min || adults > partySize.max) {
      return 0
    }

    return partySize.max - adults
  }

  getMinimumAdultNumber () {
    return 1
  }
}
